// const FORM_CHANGE = '@@redux-form/CHANGE';

export default () => next => action => next(action);
